import {
    deleteServiceLoading,
    deleteServiceRequest,
    deleteServiceSuccess,
    deleteServiceReject,
    deleteServiceReset
} from "../../actions/services/delete";

export const deleteService = (id) => async (dispatch, getState) => {
    dispatch(deleteServiceLoading());
    try {
        const { data } = await deleteServiceRequest(getState, id);
        dispatch(deleteServiceSuccess(data))
    } catch (error) {
        dispatch(deleteServiceReject(error))
    } finally {
        setTimeout(() => { dispatch(deleteServiceReset()) }, 3000);
    }
    return Promise.resolve();
};